import React from 'react';
import { observer } from 'mobx-react-lite';

import { useCurrentSpace } from '../../../hooks/use-current-space';
import { useOnClickOutside } from '../../../hooks/useOutsideClick';
import { authStore } from '../../../core/stores/auth-store';
import { MainDrawer } from './main-drawer';
import { ProjectDrawer } from './project-drawer';
import { uiStore } from '../../../core/stores/ui-store';
import { useCurrentProject } from '../../../hooks/use-current-project';
import { useResponsive } from '../../../hooks/useResponsive';

import type { Space, User } from '../../entities';

import styles from './drawer.module.scss';
export type DrawerComponentProps = {
  isOpen: boolean;
  currentUser: User;
  space: Space;
};

export const Drawer: React.FC = observer(() => {
  const currentUser = authStore.currentUser!;
  const space = useCurrentSpace();
  const project = useCurrentProject();
  const isOpen = !!uiStore.isDrawerOpen;
  const { isDesktop } = useResponsive();
  const { ref } = useOnClickOutside((e) => {
    const target = e.target as HTMLElement;
    if (target?.id === 'left-drawer-trigger') {
      return;
    }

    uiStore.isDrawerOpen = false;
  });

  return (
    <div className={styles['container']} ref={ref} data-is-open={isOpen}>
      {isDesktop || !project ? (
        <MainDrawer isOpen={isOpen} currentUser={currentUser} space={space} />
      ) : (
        <ProjectDrawer isOpen={isOpen} currentUser={currentUser} space={space} />
      )}
    </div>
  );
});
